import React from 'react';
import { useParams } from 'react-router-dom';

export function AutomedReferrals() {
    const { automedSiteId, automedPath, locationId } = useParams();

    const referralsUrl = `${import.meta.env.VITE_AUTOMED_URL}/myhealth/clinics/${automedSiteId}/${automedPath}/referrals/loc/${locationId}`;

    return <iframe className="h-screen w-screen" src={referralsUrl} />;
}
